export default __webpack_public_path__ + "static/media/0x1379e8886a944d2d9d440b3d88df536aea08d9f3.c0e4bdd5.webp";